import { Link } from "react-router-dom";
import { Header } from "./LoginOtp";

export function Home() {
    return (
        <div className="min-h-screen bg-white text-black font-body">
            <Header />
            <main className="mx-auto max-w-2xl p-8 flex flex-col gap-6">
                <h1 className="text-4xl">Account</h1>
                <Link to="/mcp" className="underline">
                    Connect to MCP
                </Link>
            </main>
        </div>
    );
}
